import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { AgreementData } from "../../models/agreement.model";
import { AgreementRepository } from "../../repositories/agreement.repository";

interface LoadAgreementUseCaseParams {
  agreementId: number;
  level: number;
}

export class LoadAgreementUseCase
  implements UseCase<LoadAgreementUseCaseParams, AgreementData>
{
  constructor(private repo: AgreementRepository) {}
  execute(param: LoadAgreementUseCaseParams): Observable<AgreementData> {
    return this.repo.loadAgreement(param.agreementId, param.level);
  }
}

const retrieveContractUseCaseFactory = (repo: AgreementRepository) =>
  new LoadAgreementUseCase(repo);

export const retrieveContractUseCaseProvider: Provider = {
  provide: LoadAgreementUseCase,
  useFactory: retrieveContractUseCaseFactory,
  deps: [AgreementRepository],
};
